import gql from 'graphql-tag';

export const GET_CALL_STATISTICS_ALL = gql`
  {
    getCallServicesHealth {
      env,
      servertype,
      avg,
      time_bucket,
      objectId,
      createdAt,
      updatedAt
    }
  }
`;

export const getAllApplications = gql`
query allApplications($filter: String!, $skip: Int, $limit: Int, $owner: String!) {
  allApplications(filter: $filter, skip: $skip, limit: $limit, owner:$owner) {
    applications{
      fields {
        applicationName
        applicationID
        developerID
        jwtTokenExpiration
        jwtServerTokenExpiration
        clientTokenScopes
        serverTokenScopes
        clientID
        clientSecret
        privateKey
        publicKey
        domain
        federationType
        version
        appType
        childAppName
        jwtOAuth2TokenExpiration
        oauth2TokenScopes
        oauth2FriendlyName
        oauth2RedirectURI
        jwtOAuth2ServerTokenExpiration
        oauth2ServerTokenScopes
        oauth2ShouldValidateEmail
      },
      ownerID,
      createdBy,
      createAt,
      updatedAt,
      className,
    },
    count,
  }
}
`;

export const GET_CALL_DETAILS = gql`
  query getCallDetails ($startTime:String, $endTime:String, $traceIds:[String]) {
    getCallDetails(startTime:$startTime, endTime:$endTime, traceIds:$traceIds) {
      traceIds {
        buckets {
          key
          milestones {
            buckets {
              key
              timestamp {
                buckets {
                  key
                  key_as_string
                  srcTN {
                    buckets {
                      key
                      dstTN {
                        buckets {
                          key
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_CALLS = gql`
  query getCalls ($appDomain:String!, $startTime:String, $endTime:String, $identifier:String!){
      getCalls(appDomain:$appDomain, startTime:$startTime, endTime:$endTime,identifier:$identifier) {
        traceId
        createdAt
        appDomain
        lastModifiedTime
        prosody{
          jicofoLeavingRoom{
            eventDateTime
            value
          }
        }
        sip_proxy{
          sipProxyReceivedSipAck{
            ACK {
              eventDateTime
              value
            }
          }
          sipProxyReceivedResponse{
            sipCodes {
              eventDateTime
              value
            }
            sip200 {
              eventDateTime
              value
            }
          }
          sipProxyReceivedNewInvite{
            INVITE {
              eventDateTime
              value
            }
          }
          sipProxyReceivedSipBye{
            BYE {
              eventDateTime
              value
            }
          }
        }
        ue_stats_wss{
          evProxyStats{
            SDK_Timeseries{
              rxAudio_bytesReceived {
                eventDateTime
                value
              }
              SDK_Timeseries {
                eventDateTime
                value
              }
              txAudio_bytesSent{
                eventDateTime
                value
              }
            }
            SDK_SignalingStateStable {
              eventDateTime
              value
            }
            SDK_ICEConnectionConnected {
              eventDateTime
              value
            }
            SDK_XMPPOccupantLeft {
              eventDateTime
              value
            }
            SDK_DataChannelOpened {
              eventDateTime
              value
            }
            SDK_ICEConnectionChecking {
              eventDateTime
              value
            }
            SDK_XMPPOccupantJoined {
              eventDateTime
              value
            }
            SDK_XMPPFocusJoined {
              eventDateTime
              value
            }
            SDK_SessionEnded {
              callDuration
              callFailureReason
              callStatus
              eventDateTime
              sdkType
              sdkVersion
              value
            }
            SDK_XMPPJingleSourceAddReceived {
              eventDateTime
              value
            }
            SDK_XMPPJingleSessionAcceptSent {
              eventDateTime
              value
            }
            SDK_XMPPJoined {
              eventDateTime
              value
            }
            SDK_SignalingStateHaveRemoteOffer {
              eventDateTime
              value
            }
            SDK_StartMucResponse {
              eventDateTime
              value
            }
            SDK_XMPPJingleSessionInitiateReceived {
              eventDateTime
              value
            }
            SDK_StartMucRequest {
              eventDateTime
              value
            }
          }
        }
        objectId
        updatedAt
        jicofo{
            MemberJoined{
            eventDateTime
            value
          }
        }
        callDateTime
        event_manager{
          evMgrPstnMUCGivenTNs{
            pstncall{
              eventDateTime
              value
            }
          }
          pstnMUCGivenTNs{
            pstncall{
              eventDateTime
              value
            }
          }
        }
        fromTN
        toTN
      }
  }
`;
